import { useState, useCallback, useEffect } from "react";

import { useResettableState } from "hooks/useResettableState";

type Params<T> = {
	value: T;
};

export function useModalField<T>({ value }: Params<T>) {
	const [currentValue, setCurrentValue, reset] = useResettableState<T>(value);

	const [isOpen, setIsOpen] = useState(false);

	const toggleIsOpen = useCallback(() => {
		setIsOpen(oldIsOpen => !oldIsOpen);
	}, [setIsOpen]);

	useEffect(() => {
		reset();
	}, [isOpen, reset]);

	return {
		currentValue,
		setCurrentValue,
		isOpen,
		setIsOpen,
		toggleIsOpen
	};
}
